let devToolsOpen = false;

function safeURL(url) {
  if (!url || typeof url !== "string") return null;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.protocol === "https:" || parsed.protocol === "http:") return url;
    return null;
  } catch {
    return null;
  }
}

function secureId() {
  try {
    return crypto.randomUUID();
  } catch {
    return (
      Date.now().toString(36) +
      Math.random().toString(36).slice(2, 10)
    );
  }
}

function sanitizeText(str) {
  if (typeof str !== "string") return "";
  return str.replace(/[<>"'&]/g, (c) => {
    return (
      {
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "&": "&amp;",
      }[c] || c
    );
  });
}

function sanitizeObj(obj) {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) return obj.map(sanitizeObj);
  if (typeof obj === "object") {
    const clean = Object.create(null);
    for (const key of Object.keys(obj)) {
      if (key === "__proto__" || key === "constructor" || key === "prototype")
        continue;
      clean[key] = sanitizeObj(obj[key]);
    }
    return clean;
  }
  return obj;
}

function detectDevTools(onDetected) {
  if (process.env.REACT_APP_ENABLE_DEVTOOLS_CHECK !== "true") {
    return () => {};
  }
  const checkTiming = () => {
    const start = performance.now();
    // eslint-disable-next-line no-debugger
    debugger;
    const elapsed = performance.now() - start;
    if (elapsed > 100 && !devToolsOpen) {
      devToolsOpen = true;
      onDetected("DevTools detected via debugger timing.");
    }
  };

  const checkSize = () => {
    const widthDiff = window.outerWidth - window.innerWidth;
    const heightDiff = window.outerHeight - window.innerHeight;
    if ((widthDiff > 200 || heightDiff > 200) && !devToolsOpen) {
      devToolsOpen = true;
      onDetected("DevTools detected via window size discrepancy.");
    }
  };

  const el = new Image();
  Object.defineProperty(el, "id", {
    get: function () {
      if (!devToolsOpen) {
        devToolsOpen = true;
        onDetected("DevTools console opened (property access trap).");
      }
      return "";
    },
  });

  const intervalId = setInterval(() => {
    checkSize();
    // eslint-disable-next-line no-console
    console.log("%c", el);
  }, 3000);

  const timingId = setInterval(checkTiming, 15000);

  return () => {
    clearInterval(intervalId);
    clearInterval(timingId);
  };
}

const isAllowedDevice = () => {
  const ua = navigator.userAgent;
  const isChrome =
    /Chrome/.test(ua) &&
    /Google Inc/.test(navigator.vendor) &&
    !/Edge|Edg|OPR|Opera/.test(ua);
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  return isChrome && !isMobile;
};

const safePnl = (val) => {
  if (typeof val === "number") return val;
  if (!val) return 0;
  const str = val.toString().replace(/[^0-9.-]+/g, "");
  return parseFloat(str) || 0;
};

export {
  safeURL,
  secureId,
  sanitizeText,
  sanitizeObj,
  detectDevTools,
  isAllowedDevice,
  safePnl,
};

